import {
  SHIPPING_ALL_VALUE,
  ShippingNamedItem,
} from '@/@types/ShippingConfigurations';
import ShippingListCell, { ShippingListItem } from './ShippingListCell';

type ShippingNamedItemsCellProps = {
  items: ShippingNamedItem[];
  modalTitle: string;
  allLabel?: string;
  linkable?: boolean;
};

function getProductDetailsHref(productId: string) {
  return `/products/edit-product/${productId}/geral`;
}

function toListItems(items: ShippingNamedItem[]): ShippingListItem[] {
  return items.map((item) => ({
    id: item.id,
    label: item.name || item.id,
  }));
}

export default function ShippingNamedItemsCell({
  items,
  modalTitle,
  allLabel,
  linkable = false,
}: ShippingNamedItemsCellProps) {
  const isAll = items.some((item) => item.id === SHIPPING_ALL_VALUE);

  return (
    <ShippingListCell
      items={toListItems(items)}
      modalTitle={modalTitle}
      allLabel={allLabel}
      isAll={isAll}
      getItemHref={
        linkable
          ? (item) =>
              item.id === SHIPPING_ALL_VALUE
                ? undefined
                : getProductDetailsHref(item.id)
          : undefined
      }
    />
  );
}
